<template>
  <section class="projects">
    <h1 class="projects__title">Project Archive</h1>
    <h5 class="projects__title--sub">A big list of things I’ve worked on</h5>
    <div class="projects__list__container">
      <ul class="projects__list">
        <li class="projects__list__item project__list__item--title">
          <div class="projects--year projects--year--title">Year</div>
          <div class="projects--title projects--title--title">Title</div>
          <div class="projects--links projects--links--title">Link</div>
        </li>

        <li
          v-for="project in projects"
          :key="project.title"
          class="projects__list__item"
        >
          <div class="projects--year">{{ project.year }}</div>
          <div class="projects--title">{{ project.title }}</div>
          <div class="projects--links">
            <a
              v-if="project.links[0].github"
              :href="project.links[0].github"
              target="_blank"
              rel="noopener noreferrer"
            >
              <font-awesome-icon
                :icon="['fab', 'github',]"
                role="presentation"
                :aria-label="Link" />
            </a>
            <a
              v-if="project.links.length > 1 && project.links[1].live"
              :href="project.links[1].live"
              style="margin-left: 0.5em;"
              target="_blank"
              rel="noopener noreferrer"
            >
              <font-awesome-icon icon="link" />
            </a>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Projects',
  data () {
    return {
      projects: [
        {
          year: '2022',
          title: 'Toronto-Cupcake',
          links: [
            { github: 'https://github.com/soumyadip001/Toronto-Cupcake' },
            { live: 'https://toronto-cupcake.netlify.app/' }
          ]
        },
        {
          year: '2022',
          title: 'Miraculous',
          links: [
            { github: 'https://github.com/soumyadip001/Miraculous' },
            { live: 'https://miraculous-app.netlify.app/' }
          ]
        },
        {
          year: '2021',
          title: 'vue-avatar-sdh',
          links: [
            { github: 'https://github.com/soumyadip001/vue-avatar-sdh' },
            { live: 'https://www.npmjs.com/package/vue-avatar-sdh' },
            { package: 'https://www.npmjs.com/package/vue-avatar-sdh' }
          ]
        },
        {
          year: '2021',
          title: 'Nuxt 3 Store Template',
          links: [
            { github: 'https://github.com/soumyadip001/firebase-store' },
            { live: null }
          ]
        },
        {
          year: '2020',
          title: 'Portfolio #3',
          links: [
            { github: 'https://github.com/soumyadip001/Portfolio' },
            { live: 'https://soumyadiphazra.netlify.app/' }
          ]
        },
        {
          year: '2020',
          title: 'Covid Map Tracker',
          links: [
            { github: 'https://github.com/soumyadip001/Covid' },
            { live: null }
          ]
        },
        {
          year: '2021',
          title: 'Book Tracker',
          links: [
            { github: 'https://github.com/soumyadip001/Book-Tracker' },
            { live: null }
          ]
        },
        {
          year: '2020',
          title: 'ASKOT Foundation',
          links: [
            { github: 'https://github.com/soumyadip001/ASKOT' },
            { live: null }
          ]
        },
        {
          year: '2020',
          title: 'SpaceX DashBoard',
          links: [
            { github: 'https://github.com/soumyadip001/SpaceX-DashBoard' },
            { live: 'https://space-x-dash-board.vercel.app/dashboard' }
          ]
        },
        {
          year: '2018',
          title: 'ThoughOfTheDay - Simple HR Solution',
          links: [
            { github: 'https://github.com/soumyadip001/ThoughOfTheDay' },
            { live: null }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/pages/projects";

</style>
